(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_47eb620"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('nav-menu-zeb')) return;

    /* ZEBBIES C5, 10 September 2026.
       This used to be an inline script tag in the page, re-downloaded on every
       page view. It now lives in the block's javascript tag, which Shopify bundles
       into a cached file. Liquid is NOT rendered in there, so the seven values
       that used to be written in by Liquid now arrive as one JSON blob in the
       data-zh-config attribute on the nav-menu-zeb element. See the root element
       in the markup above. The defaults below are only a safety net. */
    var CFG = {};
    try {
      var cfgEl = document.querySelector('nav-menu-zeb');
      if (cfgEl) { CFG = JSON.parse(cfgEl.getAttribute('data-zh-config') || '{}') || {}; }
    } catch (e) { CFG = {}; }

    var MONEY_PREFIX = CFG.moneyPrefix != null ? CFG.moneyPrefix : 'R';
    var SEARCH_URL = CFG.searchUrl || '/search';
    var CART_URL = CFG.cartUrl || '/cart';
    var SEARCH_FIELDS = 'title,product_type,variants.title,variants.sku,variants.barcode,vendor,tag';
    var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;
    var FREE_ON = CFG.freeOn === true;
    var FREE_THRESHOLD = CFG.freeThreshold || 0;
    var FREE_OK_TEXT = CFG.freeOkText || '';
    var FREE_PROGRESS_TEXT = CFG.freeProgressText || '';

    class ZebbiesHeader extends HTMLElement {
      connectedCallback() {
        this.forms = Array.from(this.querySelectorAll('.zh-search-form-zeb'));
        this.inputs = Array.from(this.querySelectorAll('.zh-search-input-zeb'));
        this.scopes = Array.from(this.querySelectorAll('.zh-scope-select-zeb'));
        this.clears = Array.from(this.querySelectorAll('.zh-search-clear-zeb'));
        this.panel = this.querySelector('.zh-panel-zeb');
        this.backdrop = this.querySelector('.zh-backdrop-zeb');
        this.panelClose = this.querySelector('.zh-panel-close-zeb');
        this.defaultPane = this.querySelector('.zh-default-zeb');
        this.resultsPane = this.querySelector('.zh-results-zeb');
        this.drawer = this.querySelector('.zh-drawer-zeb');
        this.burger = this.querySelector('.zh-burger-zeb');
        this.cartDd = this.querySelector('.zh-cart-dd-zeb');
        this.cartCounts = Array.from(this.querySelectorAll('.zh-cart-count-zeb'));
        this.timer = null;
        this.lastQuery = '';
        this.scrollLocked = false;
        this.savedScrollY = 0;

        this.bindSearch();
        this.bindDrawer();
        this.bindCart();
        this.measure();

        window.addEventListener('resize', this.measure.bind(this));
      }

      measure() {
        var mobile = this.querySelector('.zh-mobile-zeb');
        if (!mobile) return;
        var rect = mobile.getBoundingClientRect();
        this.style.setProperty('--zh-header-h-zeb', Math.round(rect.bottom) + 'px');
      }

      esc(text) {
        var d = document.createElement('div');
        d.textContent = text == null ? '' : text;
        return d.innerHTML;
      }

      money(value) {
        if (value === null || value === undefined || value === '') return '';
        var n = typeof value === 'number' ? value : parseFloat(String(value).replace(/[^0-9.]/g, ''));
        if (isNaN(n)) return '';
        return MONEY_PREFIX + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }

      highlight(text, query) {
        var safe = this.esc(text);
        var term = String(query || '').trim();
        if (!term) return safe;
        var pattern = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').split(/\s+/).join('|');
        try {
          return safe.replace(new RegExp('(' + pattern + ')', 'gi'), '<mark class="zh-mark-zeb">$1</mark>');
        } catch (e) {
          return safe;
        }
      }

      /* scroll lock - works on desktop and mobile */

      lockScroll() {
        if (this.scrollLocked) return;

        var body = document.body;
        var bar = window.innerWidth - document.documentElement.clientWidth;

        this.savedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
        this.prevStyles = {
          position: body.style.position,
          top: body.style.top,
          left: body.style.left,
          right: body.style.right,
          width: body.style.width,
          overflow: body.style.overflow,
          paddingRight: body.style.paddingRight
        };

        body.style.position = 'fixed';
        body.style.top = -this.savedScrollY + 'px';
        body.style.left = '0';
        body.style.right = '0';
        body.style.width = '100%';
        body.style.overflow = 'hidden';
        if (bar > 0) body.style.paddingRight = bar + 'px';

        this.scrollLocked = true;
      }

      unlockScroll() {
        if (!this.scrollLocked) return;

        var body = document.body;
        var prev = this.prevStyles || {};

        body.style.position = prev.position || '';
        body.style.top = prev.top || '';
        body.style.left = prev.left || '';
        body.style.right = prev.right || '';
        body.style.width = prev.width || '';
        body.style.overflow = prev.overflow || '';
        body.style.paddingRight = prev.paddingRight || '';

        this.scrollLocked = false;
        window.scrollTo(0, this.savedScrollY || 0);
      }

      bindSearch() {
        var self = this;

        this.inputs.forEach(function (input) {
          input.addEventListener('focus', function () {
            self.open();
            if (!input.value.trim()) self.showDefault();
          });

          input.addEventListener('input', function () {
            var value = input.value;
            self.syncInputs(input, value);
            self.classList.toggle('zh-has-query', value.trim().length > 0);
            self.open();

            clearTimeout(self.timer);
            if (!value.trim()) {
              self.showDefault();
              return;
            }
            self.timer = setTimeout(function () {
              self.search(value.trim());
            }, 250);
          });
        });

        this.scopes.forEach(function (select) {
          select.addEventListener('change', function () {
            self.scopes.forEach(function (other) {
              other.value = select.value;
            });
            var query = self.currentQuery();
            if (query) {
              self.search(query);
            } else {
              self.showDefault();
            }
          });
        });

        this.clears.forEach(function (button) {
          button.addEventListener('click', function () {
            self.inputs.forEach(function (input) {
              input.value = '';
            });
            self.classList.remove('zh-has-query');
            self.showDefault();
            self.close();
          });
        });

        if (this.backdrop) {
          this.backdrop.addEventListener('click', function () {
            self.close();
          });
        }

        if (this.panelClose) {
          this.panelClose.addEventListener('click', function () {
            self.close();
            self.inputs.forEach(function (input) {
              input.blur();
            });
          });
        }

        this.forms.forEach(function (form) {
          form.addEventListener('submit', function (event) {
            event.preventDefault();
            var query = self.currentQuery();
            if (!query) return;
            var scope = self.currentScope();
            var url = SEARCH_URL + '?q=' + encodeURIComponent(query);
            if (scope === 'products') url += '&type=product';
            if (scope === 'advice') url += '&type=article';
            self.unlockScroll();
            window.location.href = url;
          });
        });

        document.addEventListener('click', function (event) {
          if (!self.contains(event.target)) self.close();
        });

        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') {
            self.close();
            self.inputs.forEach(function (input) {
              input.blur();
            });
          }
        });

        this.addEventListener('click', function (event) {
          if (event.target.closest && event.target.closest('a[href]')) self.unlockScroll();
        });
      }

      currentQuery() {
        var value = '';
        this.inputs.forEach(function (input) {
          if (input.value.trim()) value = input.value.trim();
        });
        return value;
      }

      currentScope() {
        return this.scopes.length ? this.scopes[0].value : 'all';
      }

      syncInputs(source, value) {
        this.inputs.forEach(function (input) {
          if (input !== source) input.value = value;
        });
      }

      open() {
        if (this.classList.contains('zh-panel-open')) return;
        this.classList.add('zh-panel-open');
        this.lockScroll();
      }

      close() {
        if (!this.classList.contains('zh-panel-open')) return;
        this.classList.remove('zh-panel-open');
        this.unlockScroll();
      }

      showDefault() {
        this.defaultPane.style.display = '';
        this.resultsPane.style.display = 'none';
      }

      showResults(html) {
        this.resultsPane.innerHTML = html;
        this.defaultPane.style.display = 'none';
        this.resultsPane.style.display = '';
      }

      search(query) {
        var self = this;
        var scope = this.currentScope();
        var types = [];

        if (scope === 'all') types = ['product', 'query', 'article'];
        else if (scope === 'products') types = ['product'];
        else if (scope === 'suggestions') types = ['query'];
        else types = ['article'];

        var url =
          '/search/suggest.json?q=' +
          encodeURIComponent(query) +
          '&resources[type]=' +
          types.join(',') +
          '&resources[limit]=5' +
          '&resources[options][unavailable_products]=last' +
          '&resources[options][fields]=' +
          encodeURIComponent(SEARCH_FIELDS);

        this.lastQuery = query;
        this.open();

        fetch(url)
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            if (self.lastQuery !== query) return;
            self.showResults(self.render(data.resources.results || {}, query, scope));
          })
          .catch(function () {
            self.showResults(
              '<div class="zh-sec-zeb"><p class="zh-empty-zeb">Search is unavailable right now.</p>' +
                '<a class="zh-viewall-zeb" href="' +
                SEARCH_URL +
                '?q=' +
                encodeURIComponent(query) +
                '">See all results</a></div>'
            );
          });
      }

      render(results, query, scope) {
        var self = this;
        var products = results.products || [];
        var queries = results.queries || [];
        var articles = results.articles || [];
        var html = '';

        if (scope === 'all' || scope === 'products') {
          html += '<div class="zh-sec-zeb"><h3 class="zh-sec-title-zeb">Products</h3>';
          if (products.length) {
            html += '<div class="zh-cards-zeb">';
            products.forEach(function (product) {
              html += self.card(product);
            });
            html += '</div><div class="zh-rows-zeb">';
            products.forEach(function (product) {
              html += self.row(product);
            });
            html += '</div>';
          } else {
            html += '<p class="zh-empty-zeb">No products match &ldquo;' + self.esc(query) + '&rdquo;.</p>';
          }
          html += '</div>';
        }

        if (scope === 'all' || scope === 'suggestions') {
          html += '<div class="zh-sec-zeb"><h3 class="zh-sec-title-zeb">Suggestions</h3><div class="zh-sugg-zeb">';
          if (queries.length) {
            queries.forEach(function (item) {
              html +=
                '<a href="' +
                SEARCH_URL +
                '?q=' +
                encodeURIComponent(item.text) +
                '">' +
                self.highlight(item.text, query) +
                '</a>';
            });
          } else {
            html += '<p class="zh-empty-zeb">No suggestions for &ldquo;' + self.esc(query) + '&rdquo;.</p>';
          }
          html += '</div></div>';
        }

        if (scope === 'all' || scope === 'advice') {
          html += '<div class="zh-sec-zeb"><h3 class="zh-sec-title-zeb">Advice</h3><div class="zh-advice-list-zeb">';
          if (articles.length) {
            articles.forEach(function (article) {
              var image = article.image || '';
              html +=
                '<a href="' +
                article.url +
                '">' +
                (image
                  ? '<img class="zh-advice-thumb-zeb" src="' + image + '" alt="" loading="lazy">'
                  : '') +
                '<span>' +
                self.esc(article.title) +
                '</span></a>';
            });
          } else {
            html += '<p class="zh-empty-zeb">No advice articles match &ldquo;' + self.esc(query) + '&rdquo;.</p>';
          }
          html += '</div></div>';
        }

        html +=
          '<a class="zh-viewall-zeb" href="' +
          SEARCH_URL +
          '?q=' +
          encodeURIComponent(query) +
          '">See all results for &ldquo;' +
          this.esc(query) +
          '&rdquo;</a>';

        return html;
      }

      priceParts(product) {
        var price = parseFloat(product.price);
        var compareRaw = product.compare_at_price_max || product.compare_at_price;
        var compare = compareRaw ? parseFloat(compareRaw) : 0;
        var onSale = compare && compare > price;
        return {
          price: this.money(price),
          was: onSale ? '<span class="zh-was-zeb">' + this.money(compare) + '</span>' : '',
          badge: onSale
            ? '<span class="zh-card-badge-zeb">Save ' + this.money(compare - price) + '</span>'
            : ''
        };
      }

      card(product) {
        var image = product.featured_image ? product.featured_image.url : product.image;
        var p = this.priceParts(product);

        return (
          '<a class="zh-card-zeb" href="' +
          product.url +
          '">' +
          p.badge +
          (image ? '<img class="zh-card-img-zeb" src="' + image + '" alt="" loading="lazy">' : '') +
          '<span class="zh-card-title-zeb">' +
          this.esc(product.title) +
          '</span><span class="zh-card-price-zeb">' +
          p.price +
          p.was +
          '</span></a>'
        );
      }

      row(product) {
        var image = product.featured_image ? product.featured_image.url : product.image;
        var p = this.priceParts(product);

        return (
          '<a class="zh-row-zeb" href="' +
          product.url +
          '">' +
          (image ? '<img class="zh-row-img-zeb" src="' + image + '" alt="" loading="lazy">' : '') +
          '<span><span class="zh-row-title-zeb">' +
          this.esc(product.title) +
          '</span><span class="zh-row-price-zeb">' +
          p.price +
          p.was +
          '</span></span></a>'
        );
      }

      /* free delivery */

      shipBar(totalCents) {
        if (!FREE_ON) return '';

        if (totalCents >= FREE_THRESHOLD && totalCents > 0) {
          return '<div class="zh-ship-bar-zeb zh-ok">' + this.esc(FREE_OK_TEXT) + '</div>';
        }

        var remaining = FREE_THRESHOLD - totalCents;
        return (
          '<div class="zh-ship-bar-zeb">' +
          this.esc(FREE_PROGRESS_TEXT).replace('[amount]', this.money(remaining / 100)) +
          '</div>'
        );
      }

      /* live cart */

      bindCart() {
        var self = this;

        if (!window.__zhCartPatched) {
          window.__zhCartPatched = true;

          var announce = function () {
            document.dispatchEvent(new CustomEvent('zh:cart:changed'));
          };

          if (window.fetch) {
            var origFetch = window.fetch;
            window.fetch = function (input) {
              var href = typeof input === 'string' ? input : (input && input.url) || '';
              return origFetch.apply(this, arguments).then(function (response) {
                if (CART_RE.test(href)) setTimeout(announce, 0);
                return response;
              });
            };
          }

          var origOpen = XMLHttpRequest.prototype.open;
          XMLHttpRequest.prototype.open = function (method, url) {
            this.__zhUrl = url;
            return origOpen.apply(this, arguments);
          };

          var origSend = XMLHttpRequest.prototype.send;
          XMLHttpRequest.prototype.send = function () {
            var xhr = this;
            xhr.addEventListener('load', function () {
              if (CART_RE.test(xhr.__zhUrl || '')) setTimeout(announce, 0);
            });
            return origSend.apply(this, arguments);
          };
        }

        document.addEventListener('zh:cart:changed', function () {
          self.refreshCart();
        });

        window.addEventListener('pageshow', function (event) {
          if (event.persisted) self.refreshCart();
        });
      }

      refreshCart() {
        var self = this;
        fetch(CART_URL + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            self.renderCart(cart);
          })
          .catch(function () {});
      }

      renderCart(cart) {
        var self = this;
        var total = cart.total_price || 0;

        this.cartCounts.forEach(function (el) {
          el.textContent = cart.item_count;
        });

        this.classList.toggle('zh-free-ship', !!FREE_ON && cart.item_count > 0 && total >= FREE_THRESHOLD);
        this.measure();

        if (!this.cartDd) return;

        if (!cart.item_count) {
          this.cartDd.innerHTML = this.shipBar(0) + '<p class="zh-cart-empty-zeb">Your cart is empty</p>';
          return;
        }

        var html = this.shipBar(total);

        cart.items.forEach(function (item) {
          var image = item.image || '';
          if (image) image += (image.indexOf('?') > -1 ? '&' : '?') + 'width=160';
          html +=
            '<a class="zh-cart-item-zeb" href="' +
            item.url +
            '">' +
            (image ? '<img class="zh-cart-item-img-zeb" src="' + image + '" alt="" loading="lazy">' : '') +
            '<span><span class="zh-cart-item-title-zeb">' +
            self.esc(item.product_title) +
            '</span><span class="zh-cart-item-meta-zeb">' +
            item.quantity +
            ' &times; ' +
            self.money(item.final_price / 100) +
            '</span></span></a>';
        });

        html +=
          '<div class="zh-cart-total-zeb"><span>Total:</span><span>' +
          this.money(total / 100) +
          '</span></div>' +
          '<a class="zh-cart-btn-zeb" href="' +
          CART_URL +
          '">View Cart</a>';

        this.cartDd.innerHTML = html;
      }

      bindDrawer() {
        var self = this;

        if (this.burger) {
          this.burger.addEventListener('click', function () {
            var open = self.classList.toggle('zh-drawer-open');
            self.burger.setAttribute('aria-expanded', open ? 'true' : 'false');
            self.drawer.setAttribute('aria-hidden', open ? 'false' : 'true');

            if (open) {
              self.close();
              self.lockScroll();
              self.measure();
            } else {
              self.unlockScroll();
            }
          });
        }

        if (this.drawer) {
          this.drawer.addEventListener('click', function (event) {
            if (event.target.closest && event.target.closest('a[href]')) self.unlockScroll();
          });
        }

        Array.from(this.querySelectorAll('button.zh-acc-head-zeb')).forEach(function (head) {
          head.addEventListener('click', function () {
            var item = head.closest('.zh-acc-item-zeb');
            var open = item.classList.toggle('zh-open');
            head.setAttribute('aria-expanded', open ? 'true' : 'false');
          });
        });
      }
    }

    customElements.define('nav-menu-zeb', ZebbiesHeader);
  })();
  } catch(e) { console.error(e); }
})();

})();
